import { AudioControllerBehavior, BaseController, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther/dist"
import { eventDispatchers } from "../Constants/EventDispatchers";
import { dispatcher, IEvent, ingenuity, Meter } from "@quest/base-core";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotConstants } from "@quest/slot-core";

export class BaseControllerGame extends BaseController {

  private jackpotMeter: Meter;

  /**
 * subscribeEvents method overrided for subscribe Jackpot Meters
 */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.UPDATE_JACKPOT_METER_VALUE, this.updateJackpotMeterValue, this);
    dispatcher.on(eventDispatchers.UDPATE_NEW_REELSET, this.updateNewReelSetWithSpin, this);
    dispatcher.on(eventDispatchers.PLAY_HOLD_AND_RESPIN_BLAST_ON_WIN_METER, this.playBlastAnimOnWinMeter, this);

  }
  protected unSubscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.off(eventDispatchers.UPDATE_JACKPOT_METER_VALUE, this.updateJackpotMeterValue, this);
    dispatcher.off(eventDispatchers.UDPATE_NEW_REELSET, this.updateNewReelSetWithSpin, this);
    dispatcher.off(eventDispatchers.PLAY_HOLD_AND_RESPIN_BLAST_ON_WIN_METER, this.playBlastAnimOnWinMeter, this);
  }

  /**
   * initializeComponent method overrided for initialize Jackpot Meter component
    */
  protected initializeComponent(): void {
    super.initializeComponent();
    this.jackpotMeter = this.view.getMeterById("jackpotMtr") as Meter;
  }

  /**
     * This method will update the reelsets
     */
  private updateNewReelSetWithSpin(): void {
    this.model.setReelSet([(ingenuity.parserModel as GameParserModel).getBaseReel()]);
    dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_REEL_SET);
  }
  /**
   * updateJackpotMeterValue updates jackot meter value depends on current bet
   */
  protected updateJackpotMeterValue(): void {
    let currentBet: number = ingenuity.parserModel.getCurrentTotalBet();
    const fixedJackpotAmount: number = currentBet * ingenuity.configData.fixedJackpotAmount; //update multiplier values from server - dependancy 
    this.jackpotMeter.setCurrencyFormattedValue(fixedJackpotAmount.toString());
    this.view.getContainerByID("jpContAllign").pivot.set(this.view.getContainerByID("jpContAllign").width / 2, 0);
  }

  /**
  * Override to update Jackpot Meters Values
  */
  protected onShowBaseGame(evt: IEvent): void {
    super.onShowBaseGame(evt);
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METER_VALUE);
  }
  /**
  * This method is use to play blast anim on console panel
  */
  private playBlastAnimOnWinMeter(): void {
    const winHit = this.view.getSpineById("win_blast");
    winHit.visible = true;
    winHit.playAnim("win_Hit_Anim", false)
  }
  // overrided to play sound using multiple instance
  protected onButtonRelesed(e: IEvent): void {
    if ((e.data === SlotConstants.BetPlusBtnId) || (e.data === SlotConstants.BetMinusBtnId) || (e.data === SlotConstantsBehavior.COIN_PLUS_BUTTON) || (e.data === SlotConstantsBehavior.COIN_MINUS_BUTTON)) {
      (ingenuity.soundManager as AudioControllerBehavior).playSound(SoundConstant.CHANGE_BET_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    } else {
      (ingenuity.soundManager as AudioControllerBehavior).playSound(SoundConstant.COMMON_CLICK_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    }
  }
  protected playBaseGameSoundsAfterGameIntro() {
    if (!(ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
      if (!SlotConstantsBehavior.FREEGAME_RETURN_SOUND) {
        if (!SlotConstantsBehavior.IS_PLAYED_BASE_GAMESOUND) {
          SlotConstantsBehavior.IS_PLAYED_BASE_GAMESOUND = true;
          dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.VOICE_INTRO, vol: 0.3, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });
        }
        dispatcher.fireEvent(SlotEventConstantsBehavior.HANDLE_MULTIPLE_SOUND, {
          initialSound: { id: SoundConstant.BASEGAME_BGM_INTRO, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD },
          onCompletedSound: { id: SoundConstant.BASEGAME_BGMLOOP, vol: 1, loop: true, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD }
        });
      }
      else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.BASEGAME_BGMLOOP, vol: 1, loop: true, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });
      }
      SlotConstantsBehavior.FREEGAME_RETURN_SOUND = false;
    }
  }
}
